import { gql } from "@apollo/client";

export const CREATE_CHEY_CHEY_IMAGE = gql`
  mutation CreateCheyCheyImage($image:String!, $type:String!, $title:String!, $category:String!) {
    createCheyCheyImage(image: $image, type:$type, title:$title, category:$category) {
        error {
            field
            message
            code
        }
        data {
            cheychey {
                id
                image
                type
            }
        }
    }
}
`;
export const DELETE_CHEY_CHEY_IMAGE = gql`
  mutation DeleteCheyCheyImage($chey_chey_id:UUID!) {
    deleteCheyCheyImage(chey_chey_id: $chey_chey_id) {
        data {
            message
        }
           error {
            message
            code
            field
            }
        }
    }
`;
